import "@/App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import { SiteSettingsProvider } from "@/hooks/useSiteSettings";
import { Seo } from "@/components/Seo";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Shows } from "@/components/Shows";
import { Music } from "@/components/Music";
import { Videos } from "@/components/Videos";
import { Gallery } from "@/components/Gallery";
import { Merch } from "@/components/Merch";
import { Subscribe } from "@/components/Subscribe";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { GigAnnouncement } from "@/components/GigAnnouncement";

// Code-split: keep the admin dashboard (and its heavy tabs) and legal pages
// out of the landing-page bundle that every visitor downloads.
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Terms = lazy(() => import("@/pages/Terms"));

const Home = () => (
  <SiteSettingsProvider>
    <Seo
      title="The Randy Loveless Band — Classic Rock · Montana"
      description="The Randy Loveless Band — classic rock from the 60s through the 2000s. Based in Montana. Catch us live, hear the new album 'Trapped in a Montana Winter', and join the fan list."
      path="/"
    />
    <div data-testid="landing-page" className="bg-[#0A0A0A] text-white">
      <Nav />
      <Hero />
      <Marquee />
      <About />
      <Shows />
      <Music />
      <Videos />
      <Gallery />
      <Merch />
      <Subscribe />
      <Faq />
      <Contact />
      <Footer />
      <GigAnnouncement />
    </div>
  </SiteSettingsProvider>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<div className="min-h-screen bg-[#0a0a0a]" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
